import { render, staticRenderFns } from "./SARConfigurations.vue?vue&type=template&id=52e8cdd2&"
import script from "./SARConfigurations.vue?vue&type=script&lang=js&"
export * from "./SARConfigurations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports